module.exports = __webpack_public_path__ + "img/contract-trash-btn.fde2fc30.svg";